import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { tap } from 'rxjs/operators';
import { LanguagePack } from 'src/app/model/CatalogProduct';
import { Parameter, Step } from 'src/app/model/Plan';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';

@Component({
    selector: 'app-download-file-multi',
    templateUrl: './download-file-multi.component.html',
    styleUrls: ['./download-file-multi.component.css'],
    standalone: false
})
export class DownloadFileMultiComponent implements OnInit, OnChanges {

  @Input() parameter:Parameter;
  @Input() step:Step;
  @Input() refresh:boolean;
  @Input() identifier: string = '';
  
  getDownloadFileList:any[] = [];

  constructor(private softInvSrv:SoftwareInventoryService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getDownloadFiles();
  }

  onDownloadFileSelect(): void {
    this.parameter.valueList = this.getDownloadFileList.filter((langPack) => {
                                                        return langPack.selected;
                                                      });
  }

  getDownloadFiles(): void {
    let version:string = '';
    let paramToUpdate:Parameter;

    if(this.parameter.changeEvent && this.parameter.changeEvent != ''){
      version = this.parameter.value;
      paramToUpdate = this.step.parameters[this.parameter.dependentParameter];
			paramToUpdate.valueList = [];
    }else if(this.parameter.dependencies && this.parameter.dependencies.length > 0){
      version = this.step.parameters[this.parameter.dependencies[0].name].value;
      paramToUpdate = this.parameter;
    }

    if(version != ''){
      this.softInvSrv.getDownloadFiles(version, paramToUpdate.constraints).pipe(tap(
        resp => {
          let files:LanguagePack[] = resp.body;
          if(paramToUpdate.valueList && paramToUpdate.valueList.length > 0){
            for(var valueItem in paramToUpdate.valueList){
              let index:number = files.findIndex( f => {
                return f.binaryuid == paramToUpdate.valueList[valueItem].binaryuid;
              })
  
              if(index > -1){
                files[index].selected = true;
              }
            }
            this.getDownloadFileList = files;
          }else{
            this.getDownloadFileList = files;
          }
        }
      )).subscribe();
    }

    this.refresh = false;
  }
}
